import * as types from '../constants/actionTypes';

const initialState = {
    subscriptionLogo: '',
    subscriptionLogoColor: '',
    subscriptionHighlightColor: '',
    brandLogo: '',
    brandAccentColor: '',
    brandBackgroundColor: '',
    showPortfolioLink: false,
};

export default function navigationReducer(state = initialState, action) {
    switch(action.type) {
        case types.LOAD_NAVIGATION_INFO_SUCCESS: {
            const navInfo = {
                /**
                 * Every one of these fields could be null.  Because we've explicitly chosen to load
                 * the nav info here, we want to blank out any values missing from the payload, so
                 * we don't keep an old subscription or brand logo around, since this is usually triggered
                 * when a subscription or location has changed
                 */
                subscriptionLogo: action.payload.subscriptionLogoFileName ? action.payload.subscriptionLogoFileName : '',
                subscriptionLogoColor: action.payload.subscriptionLogoColor ? action.payload.subscriptionLogoColor : '',
                subscriptionHighlightColor: action.payload.subscriptionHighlightColor ? action.payload.subscriptionHighlightColor : '',
                brandLogo: action.payload.brandLogoFileName ? action.payload.brandLogoFileName : '',
                brandAccentColor: action.payload.brandAccentColor ? action.payload.brandAccentColor : '',
                brandBackgroundColor: action.payload.brandBackgroundColor ? action.payload.brandBackgroundColor : '',
                showPortfolioLink: action.payload.showPortfolioLink === true
            }
            return {
                ...state,
                ...navInfo
            };
        }
        case types.SET_NAV_SUBSCRIPTION_LOGO: {
            return {
                ...state,
                subscriptionLogo: action.payload.logo
            };
        }
        default:
            return state;
    }
}
